import React, { Component } from 'react';
import _ from 'lodash';
import Fuse from 'fuse.js';

import PlaceRolesTable from '../components/PlaceRolesTable';
import PlaceRolesModel from '../components/PlaceRolesModel';
import PlaceRolesForm from '../components/PlaceRolesForm';
import UserModel from '../components/UserModel';

import { Layout, Button, Row, Col, Input, Icon, DatePicker, message } from 'antd';

class SettingsPlaceRolesScreen extends Component {

  fuseOptions = {
    shouldSort: true,
    includeScore: true,
    threshold: 0.1,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 2,
    keys: [
      "name"
    ]
  }

  state = {
    dataLoading: false,
    dataAll: [],
    data: [],
    placeRolesFormModalVisible: false
  }

  componentWillMount() {
    this.loadData();
  }

  loadData() {
    this.setState({
      dataLoading: true
    });
    PlaceRolesModel.getAll()
      .then(data => {
        this.setState({
          dataLoading: false,
          dataAll: data,
          data: data,
        });
      })
      .catch(err => {
        message.warning('Role pakovacích míst se nepodařilo načíst!');
        this.setState({
          dataLoading: false,
        });
      });
  }

  onSearch(searchText) {
    const dataAll = this.state.dataAll;
    this.setState({
      dataLoading: true
    })
    if (searchText) {
      let fuse = new Fuse(dataAll, this.fuseOptions);
      let results = fuse.search(searchText);
      results = results.map((result) => {
        return result.item;
      });
      this.setState({
        dataLoading: false,
        data: results
      });
    } else {
      this.setState({
        dataLoading: false,
        data: dataAll
      });
    }
  }

  render() {
    return (
      <Layout.Content style={{ margin: '24px 16px 0', minHeight: 'auto' }}>
        <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
          <h2>Systém - Role parkovacích míst</h2>
          <div style={{ marginBottom: '20px' }}>
            <Row>
              <Col span={20}>
                <Input.Search
                  placeholder="Hledat"
                  onSearch={this.onSearch.bind(this)}
                  style={{ width: 300 }} />
              </Col>
              <Col span={4} offset={0} style={{ textAlign: 'right' }}>
                <Button type="default" onClick={() => { this.loadData() }} style={{ marginRight: 10 }}>
                  <Icon type="sync" />
                </Button>
                {UserModel.isInRoles(['ADMIN', 'CORE_PLACEROLES_WRITE'])
                  ? <Button type="default" onClick={() => { this.setState({ placeRolesFormModalVisible: true }) }}>Nová role</Button>
                  : null}
              </Col>
            </Row>
          </div>
          <PlaceRolesForm
            type="modal"
            modalVisible={this.state.placeRolesFormModalVisible}
            onModalCancel={(form) => {
              form.resetFields();
              this.setState({ placeRolesFormModalVisible: false });
            }}
            onSuccess={(form, values) => {
              PlaceRolesModel.create(values)
                .then(() => {
                  this.loadData();
                  this.setState({ placeRolesFormModalVisible: false });
                })
                .catch((err) => {
                  message.warning('Data se nepodařilo uložit. Prosím kontaktujte správce systému!');
                });
            }} />
          <PlaceRolesTable
            data={this.state.data}
            loading={this.state.dataLoading}
            onRemoveRow={(id) => {
              PlaceRolesModel.remove(id)
                .then(() => {
                  this.loadData();
                  message.success('Role parkovacího místa byla odstraněna')
                })
                .catch(() => {
                  message.error('Roli parkovacího místa se nepodařilo smazat!');
                })
            }}
          />
        </div>
      </Layout.Content>
    );
  }
}

export default SettingsPlaceRolesScreen;



// WEBPACK FOOTER //
// ./src/screens/SettingsPlaceRolesScreen.js